enum ExtractionArticleElementType {
    MEASURE = 'MEASURE',
    _3D = '_3D',
}

export default ExtractionArticleElementType;